module.exports = __webpack_public_path__ + "img/min-logo.97fc2543.jpg";